export enum EVENT_TYPES {
  WORKOUT = 'workout',
  TEST = 'test',
  MATCH = 'match',
  SYSTEM_TEST_EVENT = 'system-test-event',
}

export enum EVENT_TEST_TYPES {
  DROP_JUMP = 'drop-jump',
  CMJ = 'cmj',
}
